import DefinitionItem from './DefinitionItem';

export default DefinitionItem;
